import { DocumentItem, documents } from '@api';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';

export const getDocumentsPendingConsent = () => {
  return apiFetch<DocumentItem[]>(documents.pendingConsentDoc.path, {
    schema: documents.pendingConsentDoc.schema,
  });
};

export const putDocumentConsent = (id: string) => {
  return apiFetch(documents.consentToDoc.path(id), {
    method: 'put',
    body: {
      accepted: true,
    },
  });
};

export const getSignUpDocuments = (signal?: AbortSignal) => {
  return apiFetch(documents.latestDocs.path, {
    schema: documents.latestDocs.schema,
    signal,
  });
};
